import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getPlaylists, setPlaylist } from "./hostActionCreators";
import { initializePlayback } from "../VotifyPlayback/playbackActionCreators";
import { Button, Menu } from "semantic-ui-react";

class PlaylistsMenu extends Component {
  constructor(props) {
    super(props);

    this.props.loadPlaylists();
    this.selectPlaylist = this.selectPlaylist.bind(this);
  }

  selectPlaylist(playlist) {
    this.props.selectPlaylist(playlist);
    if (!this.props.isInitialized) {
      this.props.initializePlayback();
    }
  }

  render() {
    return (
      <Menu vertical inverted fluid>
        {this.props.playlists &&
          this.props.playlists.items &&
          this.props.playlists.items.map((playlist, index) => {
            return (
              <Menu.Item key={index} style={styles.menuItem}>
                <Menu.Header>{playlist.name}</Menu.Header>
                {(this.props.selectedPlaylists.find(
                  (playlistObject) => playlistObject.id === playlist.id,
                ) && (
                  <Button
                    content={"IN QUEUE"}
                    size={"tiny"}
                    loading={
                      this.props.currentlyLoadingPlaylistId === playlist.id
                    }
                    disabled
                    basic
                    inverted
                  />
                )) || (
                  <Button
                    loading={
                      this.props.currentlyLoadingPlaylistId === playlist.id
                    }
                    onClick={() => this.selectPlaylist(playlist)}
                    content={"SELECT"}
                    size={"tiny"}
                    basic
                    inverted
                  />
                )}
              </Menu.Item>
            );
          })}
      </Menu>
    );
  }
}

const styles = {
  menuItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
};

const mapStateToProps = (state) => {
  return {
    playlists: state.host.playlists,
    selectedPlaylists: state.host.selectedPlaylists,
    currentlyLoadingPlaylistId: state.host.currentlyLoadingPlaylistId,
    isInitialized: state.playback.isInitialized,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadPlaylists: () => dispatch(getPlaylists()),
    selectPlaylist: (playlist) => dispatch(setPlaylist(playlist)),
    initializePlayback: (playlist) => dispatch(initializePlayback(playlist)),
  };
};

PlaylistsMenu.propTypes = {
  loadPlaylists: PropTypes.func.isRequired,
  selectPlaylist: PropTypes.func.isRequired,
  selectedPlaylists: PropTypes.array.isRequired,
  isInitialized: PropTypes.bool.isRequired,
  currentlyLoadingPlaylistId: PropTypes.string,
  playlists: PropTypes.object,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlaylistsMenu);
